import castArray from 'lodash/castArray';
import * as availableRules from './rules';

export default class Validator {
  constructor(rules = []) {
    this.rules = rules;
  }

  validate(seat, rules) {
    rules = rules || this.rules;

    // Makes sure that blocks for this seat/group are generated
    seat.block;

    // Technically it shouldn't be possible to click a
    // blocked seat in the first place, but here we go
    if (seat.isBlocked()) return;

    // Determine which ruleset to use
    const action = seat.isSelected()
      ? 'deselect'
      : 'select';

    const result = {
      option: null,
      valid: true,
    };

    rules.some(rule => {
      const { valid, option, stop } = this.check(seat, rule, action);

      result.valid = result.valid && valid;

      if (option) {
        result.option = option;
      }

      return stop;
    });

    return result;
  }

  check(seat, rule, action) {
    const ruleset = availableRules[rule][action];

    const params = {
      group: seat.group,
      block: seat.block,
      seat,
    }

    const result = {
      option: null,
      valid: true,
      stop: false,
    };

    Object.keys(ruleset).some(key => {

      // Check if the rule matches the selection
      if (!ruleset[key][0](params)) return false;

      // console.log(key, action, rule, seat);

      const {
        valid,
        stop = true,
        select = null,
        deselect = null,
      } = ruleset[key][1](params);

      result.valid = result.valid && valid;
      result.stop = stop;

      if (select || deselect)
        result.option = {
          deselect: castArray(deselect ?? []),
          select: castArray(select ?? []),
        }

      return stop;
    });

    return result;
  }
}
